import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=08ad5f36&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=08ad5f36&prod&scoped=true&lang=css"
import style1 from "./ItemDetail.vue?vue&type=style&index=1&id=08ad5f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad5f36",
  null
  
)

export default component.exports